import { createSelector } from 'reselect'

const workflowBuilderSelector = ({ workflows: { builder } }) => builder

export const workflowBuilderActionEditSelector = createSelector(
  workflowBuilderSelector,
  ({ actionToEdit }) => actionToEdit
)
